<template>
	<div class="mb-4">
		<ProductsList></ProductsList>
	</div>
</template>

<script>
import ProductsList from '@/components/Widgets/Products/ProductsList/ProductsList.vue';
export default {
  name: 'Products',
  components: {
    ProductsList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>